import { render } from "./MajorCategory.vue?vue&type=template&id=4c20e505"
import script from "./MajorCategory.vue?vue&type=script&lang=js"
export * from "./MajorCategory.vue?vue&type=script&lang=js"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__